// extracted by mini-css-extract-plugin
export default {"wrap":"DayCounter_wrap__-l56x","headline":"DayCounter_headline__Eih0G"};